import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "hasDoneInitialMeasure", "popper", "show"];
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix, useIsRTL } from './ThemeProvider';
import { getOverlayDirection } from './helpers';
import getInitialPopperStyles from './getInitialPopperStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'right' : _ref$placement,
    className = _ref.className,
    style = _ref.style,
    children = _ref.children,
    arrowProps = _ref.arrowProps,
    hasDoneInitialMeasure = _ref.hasDoneInitialMeasure,
    popper = _ref.popper,
    show = _ref.show,
    props = _objectWithoutProperties(_ref, _excluded);
  bsPrefix = useBootstrapPrefix(bsPrefix, 'tooltip');
  var isRTL = useIsRTL();
  var _ref2 = (placement == null ? void 0 : placement.split('-')) || [],
    _ref3 = _slicedToArray(_ref2, 1),
    primaryPlacement = _ref3[0];
  var bsDirection = getOverlayDirection(primaryPlacement, isRTL);
  var computedStyle = style;
  if (show && !hasDoneInitialMeasure) {
    computedStyle = _objectSpread(_objectSpread({}, style), getInitialPopperStyles(popper == null ? void 0 : popper.strategy));
  }
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: ref,
    style: computedStyle,
    role: "tooltip",
    "x-placement": primaryPlacement,
    className: classNames(className, bsPrefix, "bs-tooltip-".concat(bsDirection))
  }, props), {}, {
    children: [/*#__PURE__*/_jsx("div", _objectSpread({
      className: "tooltip-arrow"
    }, arrowProps)), /*#__PURE__*/_jsx("div", {
      className: "".concat(bsPrefix, "-inner"),
      children: children
    })]
  }));
});
Tooltip.displayName = 'Tooltip';
export default Object.assign(Tooltip, {
  // Default tooltip offset.
  // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
  TOOLTIP_OFFSET: [0, 6]
});